import { PropsWithChildren, useMemo, useState } from 'react';
import { createSafeContext } from '@mews/framework';
import { RoutingRulesFormStepName } from '../types';

interface RoutingRuleFormStepContextValue {
    currentStep: RoutingRulesFormStepName;
    setCurrentStep: (step: RoutingRulesFormStepName) => void;
    completedSteps: RoutingRulesFormStepName[];
    setCompletedSteps: (steps: RoutingRulesFormStepName[]) => void;
}

export const { RoutingRuleFormStepContextProvider: ContextProvider, useRoutingRuleFormStepContext } = createSafeContext<
    'RoutingRuleFormStepContext',
    RoutingRuleFormStepContextValue
>('RoutingRuleFormStepContext');

export const RoutingRuleFormStepContextProvider = ({ children }: PropsWithChildren<{}>) => {
    const [currentStep, setCurrentStep] = useState<RoutingRulesFormStepName>(RoutingRulesFormStepName.Timing);
    const [completedSteps, setCompletedSteps] = useState<RoutingRulesFormStepName[]>([]);

    const contextValue = useMemo(
        () => ({
            currentStep,
            setCurrentStep,
            completedSteps,
            setCompletedSteps,
        }),
        [currentStep, setCurrentStep, completedSteps, setCompletedSteps]
    );

    return <ContextProvider value={contextValue}>{children}</ContextProvider>;
};
